import styled from 'styled-components';

const ContentHeader = styled.div`
  border-bottom: 1px solid #e9e9e9;
  color: #333;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5rem;
  margin: 1.5rem 0 1rem;
  padding: 0 0 0.25rem;
  width: 100%;

  &:first-of-type {
    margin: 0 0 1rem;
  }
`;

export default ContentHeader;
